import {createSlice} from "@reduxjs/toolkit";
import {deleteObjectFromArrayOfObjects} from "../../../_helpers/helperFunctions";

export const newCategoryInitialValue = {
    title: '',
    description: '',
    mask: 'PCM-0001',
    maskCode: '',
    maskCodePrefix: 'PCM',
    maskCodeCounter: 1,
    mydata: '[]',
    taxes: '{}',
    accounting: '',
    extra: '',
    isActive: 'active',
    type: 'product',
    measurementUnit: "",
    defaultProperties: {}
}

export const newProductsCategoryMyDataInitialValue = {
    id: 0,
    name: '',
    invoiceType: '',
    category: '',
    type: '',
}

const defaultPropertyInitialState = {
    name: "",
    values: ""
}

const initialState = {
    loading: false,
    hasErrors: false,
    categories: [],
    subCategories: [],
    newProductsCategoryMyDataInitialValue: newProductsCategoryMyDataInitialValue,
    newProductsCategoryMyData: newProductsCategoryMyDataInitialValue,
    newCategoryInitialValue: newCategoryInitialValue,
    newCategory: newCategoryInitialValue,
    tempNewDefaultProperties: defaultPropertyInitialState,
    selectedProductCategory: {}
};

export const ProductCategorySlice = createSlice({
    name: "product_category",
    initialState,
    reducers: {
        deleteProductCategory: (state, {payload}) => {
            state.categories = state.categories.filter((item) => item['_id'] !== payload.id);
            state.loading = false;
            state.hasErrors = false;
        },
        setProductCategory: (state, {payload}) => {
            state.categories = deleteObjectFromArrayOfObjects(payload, 'active', 'inActive');
            state.loading = false;
            state.hasErrors = false;
        },
        setProductSubCategories: (state, {payload}) => {
            state.subCategories = payload;
        },
        setNewCategory: (state, {payload}) => {
            state.newCategory = payload;
        },
        setNewProductsCategoryMyData: (state, {payload}) => {
            state.newProductsCategoryMyData = payload;
        },
        setTempNewDefaultProperties: (state, {payload}) => {
            state.tempNewDefaultProperties = payload;
        },
        resetTempNewDefaultProperties: (state) => {
            state.tempNewDefaultProperties = {...defaultPropertyInitialState};
        },
        setSelectedProductCategory: (state, {payload}) => {
            state.selectedProductCategory = payload;
        },
    },
});

export const {
    deleteProductCategory,
    setProductCategory,
    setProductSubCategories,
    setNewCategory,
    setNewProductsCategoryMyData,
    setTempNewDefaultProperties,
    resetTempNewDefaultProperties,
    setSelectedProductCategory
} = ProductCategorySlice.actions;
